export default class RequestError extends Error {
  private reason?: string;

  constructor(message = 'Request failed!', reason?) {
    super(message);
    this.name = 'RequestError';
    this.reason = reason;
  }
}
